// Utility function to determine the correct navigation path after status changes
export const getStatusNavigationPath = (newStatus: string): string => {
  const statusToPathMap: Record<string, string> = {
    'new_submission': '/submissions/new',
    'under_review': '/submissions/under-review',
    'profile_verified': '/submissions/verified',
    'available_for_hire': '/submissions/available',
    'hired': '/submissions/hired',
    'current_employee': '/submissions/hired',
    'rejected': '/submissions/rejected',
    'terminated': '/submissions/terminated',
    'blacklisted': '/submissions/blacklisted',
    'requested_rework': '/submissions/new' // Rework requests go back to new submissions
  };

  return statusToPathMap[newStatus] || '/submissions/new';
};

// Function to get the current page path for navigation back
export const getCurrentPagePath = (currentStatus: string): string => {
  return getStatusNavigationPath(currentStatus);
};
